import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfCentralFlorida = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Central Florida"
      universityShortName="UCF"
      slug="university-of-central-florida"
      seoTitle="UCF Study Rooms | University of Central Florida Study Spaces"
      seoDescription="Find study rooms at UCF including John C. Hitt Library group rooms. Learn booking policies, student tips, and discover CSW as an online alternative."
      seoKeywords="UCF study rooms, University of Central Florida library, UCF library study rooms, UCF group study rooms, Orlando study spaces"
      canonicalUrl="/study-room/university-of-central-florida/"
      heroDescription="Navigate UCF's study room booking system and find the best spots on campus for focused studying."
      libraryWebsiteUrl="https://library.ucf.edu"
      libraryWebsiteName="UCF Libraries"
      studySpaces={[
        {
          name: "John C. Hitt Library - Group Rooms",
          features: "30-min increments, up to 4 hours/day, 16 hours/month. Large rooms for 6+ students, whiteboards available.",
          feedback: "Rooms often booked days in advance. Check-in within 15 minutes required or reservation forfeited."
        },
        {
          name: "John C. Hitt Library - Upper Floors",
          features: "Individual desks and carrels, quiet study zones, natural lighting.",
          feedback: "Best for solo quiet study. Less crowded than lower floors."
        },
        {
          name: "Café Bustelo Area",
          features: "Casual seating near coffee kiosk, open collaborative space.",
          feedback: "Good for light studying with coffee. Can be noisy during peak hours."
        }
      ]}
      guideContent={
        <>
          <p>
            To secure a study room at UCF, reserve as soon as slots open—three days ahead for large rooms. 
            Bring your group on time and check in within 15 minutes to avoid losing your reservation.
          </p>
          <p className="mt-4">
            Many group rooms are used as private hangout spaces and often booked out days in advance. 
            New policies enforce time limits and discourage long squatting sessions.
          </p>
          <p className="mt-4">
            If you need solo quiet space, head to the higher floors of the John C. Hitt Library, which offer 
            desks and carrels. Pair your session with coffee from the nearby Café Bustelo kiosk.
          </p>
        </>
      }
      summaryTips={[
        "Book rooms 3 days in advance for large group rooms",
        "Check in within 15 minutes or lose your reservation",
        "Upper floors of Hitt Library are quieter for solo study",
        "Automated bots are banned from the booking system",
        "Use CSW for 24/7 virtual study when rooms are full"
      ]}
    />
  );
};

export default UniversityOfCentralFlorida;
